var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InventoryEditAdmin',{attrs:{"Inventory":_vm.Inventory},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }